export default __webpack_public_path__ + "static/media/footer.b5a78817.png";